import {
  PARAMOUNT_REGEXP,
  TV_PLAN_CARD_GIGA_TV_PREFIX,
  TV_PLAN_CARD_VALUES,
  TV_PLAN_LINKS,
  TV_PLAN_STATUS,
  TV_PLAN_STATUS_LABEL,
} from 'app-constants'
import { contractService } from 'services'

async function getTvLink(contractId, productId, itemCode) {
  const { getTvActivationLink } = contractService()

  try {
    const params = { contractId, productId, productName: itemCode }
    const { data } = await getTvActivationLink(params)

    return { tvPlanKey: itemCode, activationLink: data.activationLink }
  } catch (error) {
    console.error(error)

    return { tvPlanKey: itemCode, activationLink: null }
  }
}

export async function getTvLinks(contractId, additionals = []) {
  const tvPlans = additionals.filter(tvPlan => {
    const { itemCode } = tvPlan
    const hasIntegrationError = hasIntegrationErrorTvPlan(tvPlan)
    const isGigaTv = itemCode.includes(TV_PLAN_CARD_GIGA_TV_PREFIX)
    const isOtt = TV_PLAN_CARD_VALUES.includes(itemCode)
    return !hasIntegrationError && (isGigaTv || isOtt)
  })
  const requests = []

  // eslint-disable-next-line no-restricted-syntax
  for (const tvPlan of tvPlans) {
    const { productId, itemCode } = tvPlan

    requests.push(getTvLink(contractId, productId, itemCode))
  }

  return Promise.all(requests)
}

export function isTvPlanActive(tvPlan) {
  return tvPlan.status === TV_PLAN_STATUS.ACTIVE
}

export function getTvButtonInfo(tvPlan, link) {
  const { activeSva, urlDocument, integrationError } = tvPlan

  if (activeSva && (integrationError || link)) return { link, label: getTvPlanButtonLabel(tvPlan) }
  if (urlDocument) return { link: urlDocument, label: 'Manual de ativação' }
}

export function getTvPlanButtonLabel(tvPlan) {
  return isTvPlanActive(tvPlan)
    ? TV_PLAN_STATUS_LABEL[TV_PLAN_STATUS.ACTIVE]
    : TV_PLAN_STATUS_LABEL[TV_PLAN_STATUS.INACTIVE]
}

export function hasIntegrationErrorTvPlan(tvPlan) {
  return tvPlan.integrationError && !isTvPlanActive(tvPlan)
}

export function getSvaData(sva = {}) {
  const { activeSva, status, urlLogo, urlImage, itemCode, itemName } = sva

  return {
    itemCode,
    itemName,
    image: urlLogo || urlImage,
    status: activeSva ? status : null,
  }
}

export function getEnjoyNowLink(itemCode) {
  if (PARAMOUNT_REGEXP.test(itemCode)) return TV_PLAN_LINKS.PARAMOUNT

  return null
}
